import React from 'react'
import { Box, Flex, Text, Avatar, AvatarGroup } from '@chakra-ui/core'
import { TooltipList } from './TooltipList'
import { LucideIcon } from 'lucide-react'

interface PreviewAvatarsListProps {
  icon: LucideIcon
  label: string
  items: Array<{
    name: string
    profile_img_url?: string
  }>
  defaultValue?: string
  max?: number
  isGroup?: boolean
}

export const PreviewAvatarsList: React.FC<PreviewAvatarsListProps> = ({
  icon: Icon,
  label,
  items,
  defaultValue,
  max = 5,
  isGroup = false,
}) => {
  return (
    <Flex align="center" h="25px" style={{ columnGap: '5px' }}>
      <Box>
        <Icon size={16} />
      </Box>
      <Text fontSize="sm">
        {label} {items.length > 0 ? ` ${items.length}:` : ''}
        <Text as="span" color="gray.400">
          {items.length > 0 ? '' : `: ${defaultValue}`}
        </Text>
      </Text>
      <TooltipList items={items.map((item) => item.name)} defaultValue={defaultValue}>
        <AvatarGroup size="xs" max={max} spacing="-0.4rem">
          {items.map(
            (item, index) =>
              item && (
                <Avatar
                  key={index}
                  size="xs"
                  src={item.profile_img_url}
                  name={item.name}
                  title={item.name}
                  {...(isGroup && {
                    bg: 'gray.300',
                    color: 'gray.600',
                  })}
                />
              )
          )}
        </AvatarGroup>
      </TooltipList>
    </Flex>
  )
}
